/**
 * Making this a dedicated resource page for things like forgot password, update profile, etc. 
 * 
 * login and register still live top level. 
 */
import { lazy } from 'react';

// lazy load the routes so they aren't included in the intial bundle and don't load until they are needed or until we decide to preload them (currently not preloading admin routes)
export const user = lazy(() => import('../resources/user/UserRouter.jsx'));
